// removed by extract-text-webpack-plugin
module.exports = {"header":"app-pages-Library-Promo-UpdateConfirmationModal-__UpdateConfirmationModal___2WAMe","dialog":"app-pages-Library-Promo-UpdateConfirmationModal-__UpdateConfirmationModal___2QPtL"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Library/Promo/UpdateConfirmationModal/UpdateConfirmationModal.css
// module id = 2453
// module chunks = 0